import { useTranslation } from "react-i18next"
import { ComboEntity } from "../../Objects/Combo/ComboEntity"
import { comboMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetCombo = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetCombo = async (onSuccess: any, rote: string = API_ROUTES.COMBO.GET_ALL) => {
    enableLoad()
    
    try {
      const response = await GetRequest<ComboEntity[]>(rote)

      if (response.success) {
        comboMemory.setList(response.data?.map((e) => new ComboEntity(e)) ?? [])

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleGetCombo }
}
